module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('em', [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/007_Preface#fm-1"
    }
  }, [_c('em', [_vm._v("Preface to Volume 5")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Introduction#fm-2"
    }
  }, [_vm._v("Introduction: The Free Speech and Establishment Clauses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01#pt-1"
    }
  }, [_c('strong', [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NE")]), _vm._v(": F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REEDOM")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OF")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGIOUS")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PEECH")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01a#ch-1"
    }
  }, [_c('strong', [_vm._v("A. Religious Speech in Public Schools and Universities")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01a#sec2-1"
    }
  }, [_vm._v("Equal Access and Moments of Silence: The Equal Status of Religious Speech by Private Speakers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01a#sec3-1"
    }
  }, [_c('em', [_vm._v("81 Northwestern University Law Review 1 (1986)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec2-2"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Board of Education v. Mergens")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec3-2"
    }
  }, [_c('em', [_vm._v("496 U.S. 226 (1990)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec2-3"
    }
  }, [_vm._v("The Students Won! The Supreme Court Enforces Equal Access Act")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec3-3"
    }
  }, [_c('em', [_vm._v("Christian Legal Society Quarterly 147 (Summer 1990)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec2-4"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Rosenberger v. Rector and Visitors of University of Virginia")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec3-4"
    }
  }, [_c('em', [_vm._v("515 U.S. 819 (1995)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec2-5"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Good News Club v. The Milford Central School")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec3-5"
    }
  }, [_c('em', [_vm._v("533 U.S. 98 (2001)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec2-6"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Morse v. Frederick")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter01b#sec3-6"
    }
  }, [_c('em', [_vm._v("551 U.S. 393 (2007)")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/010_Chapter01c#sec2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("High-Value Speech and the Basic Educational Mission of a Public School: Some Preliminary Thoughts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter01c#sec3-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("12 Lewis and Clark Law Review 111 (2008)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter01c#sec2-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Christian Legal Society v. Martinez")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter01c#sec3-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("561 U.S. 661 (2010)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter01c#sec2-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Vanderbilt University "), _c('em', [_vm._v("(Dec. 2, 2011)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("B. Religious Speech in the Political Process")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec2-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Freedom of Speech That Is Both Religious and Political")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec3-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("29 University of California Davis Law Review 793 (1996)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec2-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("People v. Pinkney")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec3-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2009 WL 2032030 (Mich. App. 2009)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec2-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Don’t Repeal the Johnson Amendment, Fix It: Free Speech in the Pulpit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec3-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Christian Century 10 (March 15, 2017)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("C. Religious Speech in the Workplace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec2-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Senate Testimony on EEOC Guidelines on Religious Harassment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec3-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("in The Effect of the EEOC’s Proposed Guidelines on Religion in the Workplace: Hearing Before the Senate Subcommittee on Courts and Administrative Practice 37 (June 9, 1994)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec2-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religious Harassment or Free Speech? Few Answers from EEOC")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec3-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chicago Tribune (June 17, 1994)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec2-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religion in the Workplace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter03#sec3-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("4 Employee Rights & Employment Policy Journal 87 (2000)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WO")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("STABLISHMENT")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LAUSE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04a#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("A. Religious Speech with Government Sponsorship")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04a#sec4-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("1. Prayers, Ceremonies, and Religious Instruction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04a#sec2-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward Schempp and His Family")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04a#sec3-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("38 Journal of Supreme Court History 63 (2013)")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/014_Chapter04a#sec2-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Lee v. Weisman")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04a#sec3-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("505 U.S. 577 (1992)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04b#sec2-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Senate Testimony on Religious Equality Amendments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04b#sec3-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Religious Liberty: Hearings Before the Senate Committee on the Judiciary 66 (Oct. 20, 1995)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04b#sec2-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Adler v. Duval County School Board")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04b#sec3-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("206 F.3d 1070 (11th Cir. 2000)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04c#sec2-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Santa Fe Independent School District v. Doe, 530 U.S. 290 (2000)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04c#sec3-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brief for Respondents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04c#sec3-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Supplemental Brief for Respondents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04c#sec2-21",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Elk Grove Unified School District v. Newdow, 542 U.S. 1 (2004)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04c#sec3-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Motion for Leave to File Amicus Brief")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04c#sec3-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04d#sec2-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Under God? Pledge of Allegiance Constitutionality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04d#sec3-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("http://www.pewforum.org/2004/03/19/under-god-pledge-of-allegiance-constitutionality/ (March 19, 2004)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04d#sec2-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is Teaching Intelligent Design Illegal? A Debate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04d#sec3-24",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Legal Affairs, http://legalaffairs.org/webexclusive/debateclub_id0905.msp (Sept. 26–29, 2005)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04d#sec2-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Voting with Your Feet Is No Substitute for Constitutional Rights")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04d#sec3-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("32 Harvard Journal of Law and Public Policy 29 (2009)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04e#sec2-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Town of Greece v. Galloway, 134 S. Ct. 1811 (2014)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04e#sec3-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brief of Respondents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04e#sec3-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oral Argument")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04e#sec4-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2. Passive Displays")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04f#sec2-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Van Orden v. Perry")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04f#sec3-28",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("545 U.S. 677 (2005)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04f#sec2-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("McCreary County v. American Civil Liberties Union")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04f#sec3-29",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("545 U.S. 844 (2005)")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/014_Chapter04f#sec2-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Monumental Decision: High Court Considers Constitutionality of Ten Commandments Displays on Public Property")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04f#sec3-30",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("http://www.pewforum.org/2005/02/24/a-monumental-decision-high-court-considers-constitutionality-of-ten-commandments-displays-on-public-property/ (Feb. 24, 2005)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04f#sec2-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Be Religiously Neutral")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04f#sec3-31",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("28 Legal Times, No. 27 (July 4, 2005)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04g#sec2-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Salazar v. Buono")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04g#sec3-32",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("559 U.S. 700 (2010)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04g#sec2-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Government-Sponsored Religious Displays: Transparent Rationalizations and Expedient Post-Modernism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04g#sec3-33",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("61 Case Western Reserve Law Review 1211 (2011)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("B. Government Funding of Religious Institutions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec4-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("1. Charitable Choice, or the Faith-Based Initiative")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Debate 2: Should the Government Provide Financial Support for Religious Institutions That Offer Faith-Based Social Services?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec3-34",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1 Rutgers Journal of Law and Religion 5 (1999)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Senate Testimony on Charitable Choice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec3-35",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Faith Based Solutions: What Are the Legal Issues? Hearing Before the Senate Committee on the Judiciary (June 6, 2001)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec2-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2001 House Testimony on Charitable Choice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05a#sec3-36",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Constitutional Role of Faith-Based Organizations in Competitions for Federal Social Service Funds: Hearing Before the House Subcommittee on the Constitution (June 7, 2001)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05b#sec2-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2010 House Testimony on Charitable Choice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05b#sec3-37",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Faith-Based Initiatives: Recommendations of the President’s Advisory Council on Faith-Based and Community Partnerships and Other Current Issues: Hearing Before the Subcommittee on the Constitution, Civil Rights, and Civil Liberties of the House Committee on the Judiciary (Nov. 18, 2010)")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('p', {
    staticClass: "toc-sec1"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/015_Chapter05b#sec4-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2. Funding for Religious Education")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05b#sec2-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joint Statement of Church-State Scholars on School Vouchers and the Constitution: What the United States Supreme Court Has Settled, What Remains Disputed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05b#sec3-38",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Pew Forum on Religion & Public Life (2002)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05b#sec2-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("House Testimony on Supreme Court’s School Choice Decision")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05b#sec3-39",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("in The Supreme Court’s School Choice Decision and Congress’ Authority to Enact Choice Programs: Hearing Before the House Subcommittee on the Constitution 5 (Sept. 17, 2002)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05b#sec2-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mistakes in "), _c('em', [_vm._v("Locke v. Davey")]), _vm._v(" and the Future of State Payments for Services Provided by Religious Institutions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05b#sec3-40",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("40 Tulsa Law Review 227 (2004)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05c#sec2-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Why the Supreme Court Changed Its Mind about Government Aid to Religious Institutions: It’s a Lot More Than Just Republican Appointments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05c#sec3-41",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2008 Brigham Young University Law Review 275")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec1"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05c#sec4-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3. Funding for the Church Itself")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05c#sec2-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Chris Smith and Grace Meng re Disaster Relief for Churches "), _c('em', [_vm._v("(February 12, 2013) Churches, Playgrounds, Government Dollars—and Schools?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05c#sec3-42",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("131 Harvard Law Review 133 (2017)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("C. The Establishment Clause Attack on Exemptions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec2-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Board of Education of the Kiryas Joel Village School District v. Grumet")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec3-43",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("512 U.S. 687 (1994)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec2-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church-State Game: A Symposium on "), _c('em', [_vm._v("Kiryas Joel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec3-44",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("First Things 36 (Nov. 1994)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec2-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amicus Brief in "), _c('em', [_vm._v("Cutter v. Wilkinson")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec3-45",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("544 U.S. 709 (2005)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec2-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Senator Mark Kolterman "), _c('em', [_vm._v("(March 15, 2016)")])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec2-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Oklahoma Legislators "), _c('em', [_vm._v("(April 12, 2018)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter06#sec2-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letter to Governor Mary Fallin "), _c('em', [_vm._v("(May 10, 2018)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("D. The Many Meanings of Separation of Church and State")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Underlying Unity of Separation and Neutrality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-46",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("46 Emory Law Journal 43 (1997)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Many Meanings of Separation: Reviewing Philip Hamburger, Separation of Church and State (2002)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-47",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("70 University of Chicago Law Review 1667 (2003)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Secularization in the U.S.: Overblown or Underestimated?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-48",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Sightings, https://divinity.uchicago.edu/sightings/secularization-us-overblown-or-underestimated (Nov. 5, 2015)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec2-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Review: Reviewing Thomas E. Buckley’s Establishing Religious Freedom: Jefferson’s Statute in Virginia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter07#sec3-49",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("77 Theological Studies 743 (2016)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42bd9c78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Contents.vue
// module id = 72
// module chunks = 0